import { Flex, message } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';

import { postBulkAssignStudent } from '../../shared/api/assignationRequest';
import { getSerieInfoV2 } from '../../shared/api/serieRequest';
import TagSerie from '../../shared/components/TagSerie';
import DefaultCoverV2 from '../../shared/cover/DefaultCoverV2';
import { Serie } from '../../shared/types/Serie';

import { useAuth } from '../../shared/context/TokenContext';
import EpisodeRow from '../components/EpisodeRow';
import ModalAssignements from '../components/ModalAssignements';

import { useNavigate } from 'react-router-dom';
import { Episode } from '../../shared/types/Episode';
import { mixpanelInstance } from '../../shared/utils/mixpanel';
import ModalEpisodeEdifice from '../components/ModalEpisodeEdifice';
import '../css/PageSerie.css';

interface PanelSerieProps {
  serie: Serie;
  close: () => void;
}

const KIT_PEDAGO = [
  { id: 210, link: 'https://library.edifice.io/document/a7985d50-b4a2-4623-894f-119567f9d061' },
  { id: 66, link: 'https://library.edifice.io/document/dc248833-ecb7-4366-b457-e37f1e7be261' },
  { id: 135, link: 'https://library.edifice.io/document/c923a02f-4638-42e0-ab60-913ac79befd0' },
  { id: 298, link: 'https://library.edifice.io/document/81b0e130-ada2-4baf-82e7-7f8edc438fad' },
  { id: 74, link: 'https://library.edifice.io/document/8d96a98b-30b4-4a4f-860e-f790a8e8c652' },
  { id: 246, link: 'https://library.edifice.io/document/89cb0773-5a2d-4a79-8fed-31089455eb47' },
  { id: 118, link: 'https://library.edifice.io/document/a78a6c4a-a2c6-4e02-a27c-dc05cdcfff8b' },
]

const TEMPS_FORT = [
 {
    id: 118, endAt: '06/07/2026', name: 'Temps fort Dessins animés - 06/07/2026'
  }
]

const PanelSerie: FunctionComponent<PanelSerieProps> = (props: PanelSerieProps) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { idClasse, isEdifice, isTeacher } = useAuth();
  const navigation = useNavigate();

  const [details, setDetails] = useState<Serie | undefined>(undefined);
  const [indexSeason, setIndexSeason] = useState(0);
  const [assignEp, setAssignEp] = useState<Episode | null>(null);
  const [assignedEpisodes, setAssignedEpisodes] = useState<number | null>(null);

  const [infoEp, setInfoEp] = useState<any>(null);
  const [openModalEdifice, setOpenModalEdifice] = useState(false);

  useEffect(() => {
    const loadDetails = async () => {
      const res = await getSerieInfoV2(`${props.serie.id}`);
      setDetails(res.serie);
      // console.log('🍪🍪🍪🍪🍪 ~ loadDetails ~ res:', res);
    };
    loadDetails();
  }, [props.serie.id]);

  const openAssignModal = (episode: Episode) => {
    setAssignedEpisodes(null);
    setAssignEp(episode);
  };

  const success = () => {
    messageApi.open({
      type: 'success',
      content: "L'assignation a été effectuée avec succès",
    });
  };

  const error = () => {
    messageApi.open({
      type: 'error',
      content: "Il y a eu un problème lors de l'assignation. Veuillez réessayer",
    });
  };

  const openEpisode = (episode: Episode, idSerie: number) => {
    navigation(`/reader/${episode.id}/${episode.origStartingNode ? episode.origStartingNode : episode.startingNode}`, {
      state: {
        idSerie: idSerie,
        episode: episode,
        params: { isDys: false, fontSize: 1 },
      },
    });
  };

  return (
    <div>
      {contextHolder}
      <Flex className="serie-panel-flex" style={{ padding: 30 }}>
        <Flex className="serie-panel-cover">
          <DefaultCoverV2 serie={details || props.serie} />
        </Flex>
        <Flex
          vertical
          style={{
            marginLeft: 10,
            marginTop: 10,
            marginBottom: 10,
            flexGrow: 1,
            flex: 1,
          }}>
          <div className="serie-title" style={{ color: '#120D35' }}>
            {details?.name}
          </div>
          <Flex>
            <TagSerie fontSize={12} name={`${details?.age} ans`} type="autre" />
            <TagSerie fontSize={12} name={`${details?.lang === 'fr' ? '🇫🇷' : '🇫🇷🇬🇧'}`} type="autre" />
          </Flex>
          <Flex>
            <TagSerie fontSize={12} name={`Écrit par ${details?.author}`} type="genre" />
            <TagSerie fontSize={12} name={`Illustré par ${details?.illustrator}`} type="genre" />
            {
              TEMPS_FORT.find(item => item.id === details?.id) ? (
                <TagSerie fontSize={12} name={`${TEMPS_FORT.find(item => item.id === details?.id)?.name}`} type="danger" />
              ) : null
            }
          </Flex>
          <div className="resume" style={{ marginTop: 8, color: '#120D35', flex: 1 }}>
            {details?.Seasons[indexSeason].summary}
          </div>
          {KIT_PEDAGO.find(item => item.id === details?.id) && isEdifice && isEdifice() && isTeacher && isTeacher() && (
            <a
              href={KIT_PEDAGO.find(item => item.id === details?.id)?.link}
              target="_blank"
              rel="noreferrer"
              style={{ marginTop: 12, textDecoration: 'underline', color: '#120D35' }}>
              Découvrez le kit pédagogique pour cette série !
            </a>
          )}
        </Flex>
      </Flex>
      <Flex style={{ paddingLeft: 30, paddingRight: 30, gap: 10 }}>
        {details?.Seasons &&
          details.Seasons.map((_, i) => (
            <Flex
              style={{
                cursor: 'pointer',
                padding: 10,
                backgroundColor: indexSeason === i ? '#FECF03' : '#EDEDED',
                borderRadius: 8,
                color: indexSeason === i ? '#120D35' : '#000',
                fontWeight: indexSeason === i ? 'bold' : 'normal',
              }}
              key={i}
              onClick={() => {
                setIndexSeason(i);
                setAssignedEpisodes(null);
              }}>
              <div>{`Saison ${i + 1}`}</div>
            </Flex>
          ))}
      </Flex>
      <Flex vertical gap={14} style={{ padding: 30, maxWidth: 900 }}>
        {details?.Seasons &&
          details.Seasons[indexSeason] &&
          details.Seasons[indexSeason].Episodes &&
          details.Seasons[indexSeason].Episodes.map((ep, i) => (
            <EpisodeRow
              key={i}
              episode={ep}
              serie={details}
              seasonNumber={0}
              assign={openAssignModal}
              isAssigned={assignedEpisodes === ep.id}
              onClick={(episode: Episode, idSerie: number) => {
                setInfoEp({ episode, idSerie });
                if(episode.statut === 'free') openEpisode(episode, idSerie);
                else if (isEdifice && !isEdifice()) openEpisode(episode, idSerie);
                else if (isEdifice && isEdifice()) {
                  if (isTeacher && !isTeacher()) setOpenModalEdifice(true);
                  else {
                    mixpanelInstance.track('ED - OT - Open EP');
                    openEpisode(episode, idSerie);
                  }
                }
              }}
            />
          ))}
      </Flex>

      <ModalAssignements
        open={assignEp !== null}
        episode={assignEp}
        assign={async (students: any) => {
          if (idClasse) {
            const status = await postBulkAssignStudent(assignEp!.id, idClasse, students);

            if (status && status === 200) {
              success();
              setAssignedEpisodes(assignEp!.id);
              setAssignEp(null);
            } else error();
          } else error();
        }}
        close={() => setAssignEp(null)}
      />
      <ModalEpisodeEdifice
        episode={infoEp?.episode}
        idSerie={infoEp?.idSerie}
        open={openModalEdifice && infoEp && infoEp.episode}
        onCancel={() => setOpenModalEdifice(false)}
      />
    </div>
  );
};

export default PanelSerie;
